// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import Close from "@store/Library/Components/Toolkit/Icons/Close";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { buttonResetProps } from "@store/Themes/common/props/button";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { focusUpdateStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

/* Store Custom Code - Start */
import { buttonIconOnlyProps } from "@store/Themes/common/props/button";
/* Store Custom Code - End */

const padding = pxToRemArray([20, 26]);

const modal: Styleguide["modal"] = {
    defaultProps: {
        ...buttonIconOnlyProps, // Store Custom Code
        headlineTypographyProps: {
            variant: "h2", // Store Custom Code
            /* Store Custom Code - Remove closeButtonProps, closeButtonIconProps */
        },
        cssOverrides: {
            modalTitle: css`
                padding: ${pxToRemArray(["20, 30"])}; /* Store Custom Code */
            `,
            modalContent: css`
                ${breakpointValues(padding, "padding")}
            `,
            /* Store Custom Code - Start */
            modalBody: css`
                overflow-y: auto;
            `,
            /* Store Custom Code - End */
        },
    },
};

export default modal;
